import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=bdce1c32&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdce1c32')) {
      api.createRecord('bdce1c32', component.options)
    } else {
      api.reload('bdce1c32', component.options)
    }
    module.hot.accept("./introduction.vue?vue&type=template&id=bdce1c32&", function () {
      api.rerender('bdce1c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sections/introduction/introduction.vue"
export default component.exports